import { FC, ReactNode } from 'react'
import cx from 'classnames'

import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type TextBannerProps = {
  className?: string
  title?: string
  text?: ReactNode
  button?: ActionButtonProps
  isSearchPage?: boolean
}

const TextBanner: FC<TextBannerProps> = ({
  className,
  title,
  text,
  button,
  isSearchPage,
}) => {
  return (
    <SC.Banner
      className={cx('TextBanner', className)}
      $isSearchPage={isSearchPage}
    >
      <SC.Wrapper>
        {title && <SC.Title>{title}</SC.Title>}
        {text &&
          (typeof text === 'string' ? (
            <SC.Text dangerouslySetInnerHTML={{ __html: text.toString() }} />
          ) : (
            <SC.Text>{text}</SC.Text>
          ))}
        {button && <SC.Button {...button} />}
      </SC.Wrapper>
    </SC.Banner>
  )
}

export default TextBanner
